import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Intercept all speech synthesis requests to globally apply the user's selected voice
if (typeof window !== 'undefined' && window.speechSynthesis) {
  const originalSpeak = window.speechSynthesis.speak;
  window.speechSynthesis.speak = function (utterance) {
    const selectedVoiceName = localStorage.getItem("selectedVoiceName");
    if (selectedVoiceName && window.speechSynthesis.getVoices) {
      const voices = window.speechSynthesis.getVoices();
      const voice = voices.find(v => v.name === selectedVoiceName);
      if (voice) {
        utterance.voice = voice;
      }
    }
    originalSpeak.call(window.speechSynthesis, utterance);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


